import React from "react";
import { Button } from "./ui/button";

/**
 * Unified empty-state block for list pages.
 *
 * Usage inside a table:
 *   <TableRow><TableCell colSpan={6} className="p-0"><EmptyState ... /></TableCell></TableRow>
 *
 * Or standalone:
 *   <EmptyState icon={<Users ... />} title="..." description="..." />
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  onAction,
  testid,
  className = "",
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 py-14 px-6 text-center ${className}`}
      data-testid={testid}
    >
      {icon ? (
        <div
          className="flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-400"
          aria-hidden="true"
        >
          {icon}
        </div>
      ) : null}
      <h3 className="text-sm font-semibold text-slate-700">{title}</h3>
      {description ? (
        <p className="max-w-sm text-xs text-slate-500 leading-relaxed">
          {description}
        </p>
      ) : null}
      {action && onAction ? (
        <Button
          size="sm"
          variant="outline"
          onClick={onAction}
          data-testid={testid ? `${testid}-action` : undefined}
          className="mt-1"
        >
          {action}
        </Button>
      ) : null}
    </div>
  );
}

export default EmptyState;
